import { useCallback } from "react";

import { IMask } from "../interfaces/input";

export const useMask = () => {
  const mask = useCallback((element: Element, mask: IMask) => {
    const $ = require("jquery");
    require("jquery-mask-plugin");

    $(element).mask(mask.value, mask.options);
  }, []);

  return { mask };
};
